import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=f6d22098"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6d22098')) {
      api.createRecord('f6d22098', component.options)
    } else {
      api.reload('f6d22098', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=f6d22098", function () {
      api.rerender('f6d22098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerInfo/customerCategory/edit.vue"
export default component.exports